module.exports = __webpack_public_path__ + "static/media/amcham_arena.ef466dc6.png";